import React, {useCallback, useEffect, useRef, useState} from 'react';
import './Styles/Main.css'
import ReactFlow, {
    useReactFlow,
    addEdge,
    applyEdgeChanges,
    applyNodeChanges,
    Background,
    ReactFlowProvider,
    updateEdge,
} from "react-flow-renderer";
import './Styles/MainNode.css'
import '../Components/Style/Navbar.css'
import MainNode from "./CustomNodes/MainNode";
import Sidebar from "./Components/Sidebar";
import Comment from "./CustomNodes/Comment";
import Npc from "./CustomNodes/Npc";
// import AuthContext from "../Validation/AuthContext";
import 'react-toastify/dist/ReactToastify.css';
// import {useNavigate} from "react-router-dom";

import LoadingScreen from "../Components/LoadingScreen";
import ShowIf from "./CustomNodes/ShowIf";
import SideMenu from "../Components/SideMenu";
import beautify from "json-beautify";
import ExecuteFunction from "./CustomNodes/ExecuteFunction";
import {toast, ToastContainer} from "react-toastify";
import Branch from "./CustomNodes/Branch";
import CustomData from "./CustomNodes/CustomData";
import Player from "./CustomNodes/Player";
import GlobalData from "./CustomNodes/GlobalData";
import {validate} from "uuid";
import Random from "./CustomNodes/Random";


const nodeTypes = {
    Main: MainNode,
    Comment: Comment,
    Npc: Player,
    If: ShowIf,
    Commands: ExecuteFunction,
    Branch: Branch,
    //  Data: CustomData,
    Player: Player,
    Data: GlobalData,
    Random: Random,

};

const Main = () => {

    // const {logout, ID} = useContext(AuthContext)
    const [nodes, setNodes] = useState([]);
    const [edges, setEdges] = useState([]);
    const [nodesDragble, setNodesDragble] = useState(true)
    const [zoomOnScrool, setZoomOnScrool] = useState(true)
    const [activeNode, setActtiveNode] = useState('')
    const [edgeToRemove, setEdgeToremove] = useState({node: "", edge: ""})
    const [isLoading, setIsLoading] = useState(false)
    const [fileHandler, setFileHandler] = useState(null)
    const [isFocusedHandle, setIsFocusedHandle] = useState(false)

    const [activeNodeForConnect, setActiveNodeForConnect] = useState({id: "", nodeType: ""})
    const [sourceOnConnect, setSourceOnConnect] = useState({source: "", sourceHandle: "", type: ""})
    // const [variables, setVariables] = useState({variables: [], names: []})

    // const getGlobalVariables = async () => {
    //
    //     const res = await api.getAllVariables({userId: ID, projectId: window.location.pathname.substring(1,37)})
    //     setVariables({names: res.names, variables: res.variables})
    // }


    // useEffect(()=>{
    //   const attrib =  window.document.getElementsByClassName('react-flow__attribution')
    //     attrib[0].innerHTML = ''
    //     attrib[0].style.visibility = "hidden"
    //
    // }, [])


    async function getFile() {
        try {
            const [Filehand] = await window.showOpenFilePicker({
                types: [
                    {
                        accept: {
                            'dg/*': ['.dlg']
                        }
                    },
                    {
                        accept: {
                            'dg/*': ['.txt']
                        }
                    },
                    {
                        accept: {
                            'dg/*': ['.json']
                        }
                    }
                ]
            })
            reactFlowInstance.setNodes([])
            reactFlowInstance.setEdges([])


            const fl = await Filehand.getFile()

            const text = await fl.text()

            const arr = await JSON.parse(text)
            // const fileData = await file.getFile()
            // const text = await  fileData.text()
            // if (file.kind === 'file') {
            //     // run file code
            // } else if (file.kind === 'directory') {
            //     // run directory code
            // }

            //  setFileHandler(fileHandler)

            await loadFile(arr)
            setFileHandler(Filehand)
        } catch (e) {
            toast.error('Error!', {
                position: "top-center",
                autoClose: 200,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false
            });
        }

    }

    const loadFile = async (text) => {

        text[0].map((val) => {
            createNodeOnLoad(val.id, val.position, val.text, val.type,
                val.title, val.size, val.replies,
                val.condition,
                val.commands, val.start, val.data, val.number
            )
        })
        // reactFlowInstance.setEdges(text[1])
        // setEdges(text[1])
        text[1].map((val, index) => {
            val.id = index
            reactFlowInstance.addEdges(val)
            // reactFlowInstance.addEdges({source:val.source, sourceHandle:val.sourceHandle,
            //     target: val.target, id:`${2}`})
        })

        // toast("Successfully");
        toast.success('Successfully!', {
            position: "top-center",
            autoClose: 200,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            closeButton: false
        });
    }

    const createNodeOnLoad = async (id, position, text, type, title, size, replys, condition, commands, isStart, data, randomNumber) => {


        const newNode = {
            id,
            position: {
                x: position.x,
                y: position.y
            },
            type,
            data: {
                text: text,
                title,
                start: isStart,
                size,
                active: () => {
                },
                ActivFun: () => {
                },
                setStart: setStart,
                removeNode: removeNode,
                onReplyRemove: onReplyRemove,
                // size: {width: 250, height: 100},
                textAreaRef: {style: {width: "250"}},
                condition,
                commands,
                replys,
                data,
                number: randomNumber
            },
        }
        newNode.data.mouseOverHandle = setIsFocusedHandle
        await AddNode(newNode)
    }

    const AddNode = async (q) => {
        reactFlowInstance.addNodes(q);
    }

    const CreateSaveData = () => {
        let Jsone = []
        let NodesArr = []
        let EdgesArr = []

        reactFlowInstance.getNodes().map((value) => {
            let start = value.data.start
            if (!start) {
                start = undefined;
            }
            NodesArr.push({
                id: value.id,
                type: value.type,
                start: start,
                position: value.position,
                size: value.data.size,
                title: value.data.title,
                text: value.data.text,
                replies: value.data.replys,
                data: value.data.data,
                condition: value.data.condition,
                commands: value.data.commands,
                number: value.data.number

            })
        })
        reactFlowInstance.getEdges().map((value, index) => {

            EdgesArr.push({
                source: value.source,
                sourceHandle: value.sourceHandle,
                target: value.target,
                targetHandle: value.targetHandle,
            })
        })

        Jsone.push(NodesArr)
        Jsone.push(EdgesArr)

        return beautify(Jsone, null, 2, 100)

    }

    const saveFileToJson = async () => {

        if (fileHandler) {
            try {
                let Jsone = []
                Jsone.push(reactFlowInstance.getNodes())
                Jsone.push(reactFlowInstance.getEdges())

                await saveFile(CreateSaveData())

                toast.success('Successfully!', {
                    position: "top-center",
                    autoClose: 200,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false
                });

            } catch (e) {

                toast.error('Error!', {
                    position: "top-center",
                    autoClose: 200,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false
                });
            }

        } else {
            await createFile()
        }
    }

    const saveFile = async (data) => {
        let stream = await fileHandler.createWritable();
        await stream.write(data)
        await stream.close()
    }


    const createFile = async () => {
        try {
            const fileHandler = await window.showSaveFilePicker({
                types: [
                    {
                        accept: {
                            'dg/*': ['.dlg']
                        }
                    },
                    {
                        accept: {
                            'dg/*': ['.txt']
                        }
                    },
                    {
                        accept: {
                            'dg/*': ['.json']
                        }
                    }
                ],
            })

            setFileHandler(fileHandler)


            const stream = await fileHandler.createWritable();
            await stream.write(CreateSaveData())
            await stream.close()

            toast.success('Successfully!', {
                position: "top-center",
                autoClose: 200,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false
            });

        } catch (e) {
            await toast.error('Error!', {
                position: "top-center",
                autoClose: 200,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false
            });

        }

    }

    const onReplyRemove = (nodeIndex, replyIndex) => {

        // setEdgeToremove({node: nodeIndex, edge: `${replyIndex}`})

        const changes = []
        reactFlowInstance.getEdges().forEach((val) => {
            if (val.source === nodeIndex && val.sourceHandle === `${replyIndex}`)
                changes.push({id: val.id, type: "remove"})
            if (val.target === nodeIndex && val.targetHandle === `${replyIndex}`)
                changes.push({id: val.id, type: "remove"})
        })

        reactFlowInstance.setEdges((eds) => applyEdgeChanges(changes, eds))
    }
    useEffect(() => {

        let edg = []
        for (const edge of edges) {

            if (edge.sourceHandle !== edgeToRemove.edge) {
                edg.push(edge)
            } else if (edge.source !== edgeToRemove.node) {
                edg.push(edge)
            }


            setEdges(edg)
        }

    }, [setEdgeToremove, edgeToRemove])


    const onNodesChange = useCallback(
        (changes) => {
            setNodes((nds) => applyNodeChanges(changes, nds))

            // edges.map((edg)=>{
            //
            // })

        }, [setNodes, edges, setEdges]);

    const onEdgesChange = useCallback(
        (changes) => {
            setEdges((eds) => applyEdgeChanges(changes, eds))

        }, [setEdges]);

    const onConnect = useCallback((connection) => {

        setSourceOnConnect({source: "", sourceHandle: "", type: ""})
        setActiveNodeForConnect({id: "", nodeType: ""})

        let conn = []
        setEdges((eds) => {
                conn = addEdge(connection, eds)
                return conn
            }
        )


    }, [setEdges, edges])


    const onNodeDoubleClick = useCallback((mouse, node) => {
        setActtiveNode(node.id)
        nodes.map((node) => (node.data.ActivFun()))
        node.data.active()
        SetActiveNodeParams(false)

    }, [setNodes, nodes])

    const onPaneClick = useCallback(async () => {


        setActtiveNode('')
        nodes.map((node) => {

                node.data.ActivFun()
            }
        )


        SetActiveNodeParams(true)


        if (activeNode !== '') {

            await saveToDB()


        }


    }, [setNodes, nodes, edges, setEdges, activeNode])


    const saveToDB = async () => {

        // await api.saveDialogue({
        //     userId: ID, projectId: window.location.pathname.slice(1).substring(0, 36),
        //     dialogueId: window.location.pathname.slice(-36), nodes: nodes, edges: edges
        // }, window.location.pathname.slice(1))
    }

    const SetActiveNodeParams = useCallback((param) => {
        setNodesDragble(param)

    }, [])

    const onNodeMouseEnter = useCallback(() => {
        setZoomOnScrool(false)
    }, [])

    const onNodeMouseLeave = useCallback(() => {
        setActiveNodeForConnect({id: "", nodeType: ""})
        setZoomOnScrool(true)
    }, [])

    const onNodeClick = (mouse, node) => {
        setActiveNodeForConnect({id: "", nodeType: ""})
        if (activeNode !== node.id) {
            onPaneClick()
        }
        setZoomOnScrool(true)
        setTimeout(() => setZoomOnScrool(false), 1)
    }

    const edgeUpdateSuccessful = useRef(true);
    const onEdgeUpdateStart = useCallback(() => {

        edgeUpdateSuccessful.current = false;
    }, []);

    const onEdgeUpdate = useCallback((oldEdge, newConnection) => {

        edgeUpdateSuccessful.current = true;
        setEdges((els) => updateEdge(oldEdge, newConnection, els));
    }, []);

    const onEdgeUpdateEnd = useCallback(async (_, edge) => {

        let con = []
        if (!edgeUpdateSuccessful.current) {
            await setEdges((eds) => {
                con = eds.filter((e) => e.id !== edge.id)
                return con
            });
        }
    }, [setNodes, nodes, edges, setEdges])

    //DragAndDrop

    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const reactFlowWrapper = useRef(null);

    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }, []);

    const getId = () => {
        let id = 0
        let haveEquelId = false
        do {

            haveEquelId = false
            for (const node of reactFlowInstance.getNodes()) {
                if (`${node.id}` === `${id}`) {
                    id = id + 1
                    haveEquelId = true
                    break
                }
            }
        } while (haveEquelId)

        return `${id}`;
    }


    const setStart = (nodeIndex) => {


        let nd = reactFlowInstance.getNodes()

        nd.map(val => {
            if (val.id === nodeIndex) {
                val.data.start = true
            } else val.data.start = false
        })

        reactFlowInstance.setNodes(nd)

    }

    const removeNode = (nodeIndex) => {


        const nd = reactFlowInstance.getNodes()

        let arr = []
        nd.map(val => {
            if (val.id !== nodeIndex) {
                arr.push(val)
            }
        })

        reactFlowInstance.setNodes(nds => nds.filter(node => node.id !== nodeIndex))
        setEdges(eds => eds.filter(edge => edge.source !== nodeIndex))
        setEdges(eds => eds.filter(edge => edge.target !== nodeIndex))

    }

    const onDrop = useCallback(
            async (event) => {
                event.preventDefault();

                const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
                const type = event.dataTransfer.getData('application/reactflow');

                // check if the dropped element is valid
                if (typeof type === 'undefined' || !type) {
                    return;
                }


                const position = reactFlowInstance.project({
                    x: event.clientX - reactFlowBounds.left,
                    y: event.clientY - reactFlowBounds.top,
                });

                let newNode = {}
                if (type === 'Comment') {
                    position.x = position.x - 125
                    position.y = position.y - 20
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            removeNode: removeNode,
                            text: "",
                            title: "",
                            size: {width: 250, height: 100}
                        },
                        position, zIndex: -1
                    };
                } else if (type === 'If') {
                    position.x = position.x - 20
                    position.y = position.y - 10
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            removeNode: removeNode,
                            type,
                            condition: {name:"None", type: "None",sign: ">=", value:""}
                        },
                        position
                    }
                } else if (type === 'Npc') {
                    position.x = position.x - 125
                    position.y = position.y - 20
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            setStart: setStart,
                            removeNode: removeNode,
                            start: false,
                            text: "",
                            title: "",
                            size: {width: 250, height: 100},
                            data: []
                        },
                        position,
                    };
                } else if (type === 'Player') {
                    position.x = position.x - 125
                    position.y = position.y - 20
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            setStart: setStart,
                            removeNode: removeNode,
                            textAreaRef: {style: {width: "100px"}},
                            start: false,
                            text: "",
                            title: "",
                            size: {width: 250, height: 100},
                            data: []
                        },
                        position,
                    };
                } else if (type === 'Main') {
                    position.x = position.x - 125
                    position.y = position.y - 20
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            onReplyRemove: onReplyRemove,
                            setStart: setStart,
                            removeNode: removeNode,
                            start: false,
                            text: "",
                            title: "",
                            size: {width: 250, height: 100},
                            replys: []
                        },
                        position,
                    };
                } else if (type === 'Commands') {
                    position.x = position.x - 125
                    position.y = position.y - 20
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            removeNode: removeNode,
                            commands: []

                        },
                        position,
                    };
                } else if (type === 'Branch') {
                    position.x = position.x - 20
                    position.y = position.y - 10
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            removeNode: removeNode,
                            type,
                            // size: {width: 250, height: 100},
                            condition: {name:"None", type: "None",sign: ">=", value:""}
                        },
                        position
                    }
                }else if (type === 'Random') {
                    position.x = position.x - 20
                    position.y = position.y - 10
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            removeNode: removeNode,
                            type,
                            number: 1
                        },
                        position
                    }
                }
                    // } else if (type === 'Data') {
                    //     position.x = position.x - 20
                    //     position.y = position.y - 10
                    //     newNode = {
                    //         id: getId(),
                    //         type,
                    //         data: {
                    //             active: () => {
                    //             },
                    //             ActivFun: () => {
                    //             },
                    //             removeNode: removeNode,
                    //             type,
                    //             // size: {width: 250, height: 100},
                    //             value_1: {value: "None", type: "None"},
                    //             value_2: ""
                    //         },
                    //         position
                    //     }
                // }
                else if (type === 'Data') {
                    position.x = position.x - 125
                    position.y = position.y - 20
                    newNode = {
                        id: getId(),
                        type,
                        data: {
                            active: () => {
                            },
                            ActivFun: () => {
                            },
                            setStart: setStart,
                            removeNode: removeNode,
                            size: {width: 250, height: 50},
                            data: [],
                            textAreaRef: {style: {width: "250"}}
                        },
                        position,
                    }
                }

                newNode.data.mouseOverHandle = setIsFocusedHandle

                setNodes((nds) => (nds.concat(newNode)));
            }
            ,
            [reactFlowInstance]
        )
    ;


    return (

        <ReactFlowProvider>
            <div className="reactflow-wrapper" ref={reactFlowWrapper}>
            </div>
            <ToastContainer/>
            {isLoading && <LoadingScreen/>}
            <SideMenu/>

            <div style={{
                position: "fixed",
                color: "white",
                left: "10px"
            }}>{fileHandler && fileHandler.name}</div>
            <a target="_blank" className="Patron" style={{zIndex: "10"}}
               href="https://www.patreon.com/bePatron?u=27828605">
                Support us on patreon to improve and develop the project</a>

            <span style={{
                position: "fixed",
                color: "whitesmoke",
                textTransform: "uppercase",
                fontSize: "0.8rem",
                right: "70px",
                fontWeight: "bold",
                fontStyle: "italic",
                zIndex: "100"
            }}>Version: 0.4 alpha</span>

            <div style={{position: "fixed", zIndex: "22", right: '15px', bottom: "15px"}}>
                <button className="backBatton" onClick={getFile}>Open</button>
                <button className="backBatton" onClick={saveFileToJson}>Save</button>
                <button className="backBatton" onClick={createFile}>Save As</button>
            </div>
            <ReactFlow

                attributionPosition={'top-right'}

                nodes={nodes}
                edges={edges}

                onEdgesChange={onEdgesChange}
                onNodesChange={onNodesChange}
                nodeTypes={nodeTypes}
                onConnect={onConnect}

                onNodeDoubleClick={onNodeDoubleClick}
                onPaneClick={onPaneClick}


                zoomOnDoubleClick={false}
                nodesDraggable={nodesDragble}
                // zoomOnScroll={nodesDragble || zoomOnScrool}
                zoomOnScroll={true}
                preventScrolling={false}

                onNodeMouseEnter={onNodeMouseEnter}
                onNodeMouseLeave={onNodeMouseLeave}
                onNodeClick={onNodeClick}

                onEdgeUpdate={onEdgeUpdate}
                onEdgeUpdateStart={onEdgeUpdateStart}
                onEdgeUpdateEnd={onEdgeUpdateEnd}


                onConnectStart={(mouse, params) => {

                    // if (params.handleType === 'source') {
                    setSourceOnConnect({
                        source: params.nodeId,
                        sourceHandle: params.handleId,
                        type: params.handleType
                    })
                    // } else {
                    //     setSourceOnConnect({source: "", sourceHandle: ""})
                    // }
                }}

                onNodeMouseMove={(mouse, node) => setActiveNodeForConnect({id: node.id, nodeType: node.type})}

                onMouseUp={() => {

                    if (!isFocusedHandle && activeNodeForConnect.nodeType !== "GlobalData" && activeNodeForConnect.nodeType !== "Comment") {


                        if (
                            (sourceOnConnect.source !== '') && (sourceOnConnect.sourceHandle !== '')
                            && activeNodeForConnect.id !== '' && activeNodeForConnect.nodeType !== ''
                            // (sourceOnConnect.node !== '') && (sourceOnConnect.type !== '') && sourceOnConnect.type !== "if" &&
                            // sourceOnConnect.type !== "b")
                        ) {
                            if (activeNodeForConnect.id !== '' && activeNodeForConnect.id !== activeNodeForConnect.source) {
                                let ed
                                if (sourceOnConnect.type === "source") {
                                    ed = {
                                        source: sourceOnConnect.source,
                                        target: activeNodeForConnect.id,
                                        sourceHandle: sourceOnConnect.sourceHandle,
                                        targetHandle: "in"
                                    }
                                    setEdges((edg) => {
                                        return addEdge(ed, edg)
                                    })
                                } else {
                                    if (activeNodeForConnect.nodeType !== "Main" && activeNodeForConnect.nodeType !== "Branch") {


                                        ed = {
                                            source: activeNodeForConnect.id,
                                            target: sourceOnConnect.source,
                                            sourceHandle: "out",
                                            targetHandle: "in"
                                        }
                                        setEdges((edg) => {
                                            return addEdge(ed, edg)
                                        })
                                    }
                                }


                                // reactFlowInstance.getEdges().forEach((val1) => {
                                //     reactFlowInstance.getEdges().forEach((val2)=> {
                                //         if(val1.source === val2.source && val1.){
                                //
                                //         }
                                //     })
                                //
                                //     // if (val.source === nodeIndex && val.sourceHandle === )
                                //     //     changes.push({id: val.id, type: "remove"})
                                //
                                // })

                                //setEdges((eds) => applyEdgeChanges(changes, eds))

                                // await api.saveDialogue({
                                //     userId: ID, projectId: window.location.pathname.slice(1).substring(0, 36),
                                //     dialogueId: window.location.pathname.slice(-36), nodes: nodes, edges: e
                                // }, window.location.pathname.slice(1))

                            }
                        }
                    }
                    setActiveNodeForConnect({id: "", nodeType: ""})
                    setSourceOnConnect({source: "", sourceHandle: "", type: ""})

                }}

                // translateExtent = {[[-1000   , -1000], [1000    , 1000]]}

                //DragAndDrop
                onInit={async (event) => {
                    setReactFlowInstance(event)
                }}
                onDrop={onDrop}
                onDragOver={onDragOver}

                // snapToGrid
                // snapGrid={[322, 172]}
                fitView
            >


                {/*<Controls/>*/}
                {/*<MiniMap maskColor="black"></MiniMap>*/}

                <Background
                    variant="lines"
                    gap="60"
                    color="gray"
                    size='0.2'
                />
                {/*<Controls className="Controls"/>*/}
            </ReactFlow>
            <Sidebar/>
        </ReactFlowProvider>


    );
};

export default Main;